export default {
  '6lecture': {
    'course-title': 'Introduction - Looking Critically At Groupings',
    'course-name': 'Section 6 <span class="unit-title">Introduction - <br> Looking Critically At Groupings<span>',
    'course-video': {
      'title': '',
      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
      'lecture-title': ''
    },
    'congratulation-message': 'excellent',
    'finish-section': 'You have completed Section 5A',
    'final-description': 'You understand how the Problem Definition Framework<br/>presents a map for structuring an introduction',
    'next-course-button': 'proceed to 6A',
    'dashboard-button': 'Main menu',
  }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/6/lecture/i18n/en.js